import { Helper } from "../helpers/helper";
import { DocumentItem, ImisPayloadFieldType, ImisResponseItems } from "../models/imis.models";
import { PayloadUtility } from "./payload.utility";
import { RestUtility } from "./rest.utility";

export class DocumentsUtility {

    public static getDocumentsByType(documentType: string, isSystem: boolean, isPublishedOnly: boolean): Promise<ImisResponseItems<DocumentItem>> {
        return RestUtility.restApiGetDataAll<DocumentItem>("/api/documentsummary", {
            documenttypeid: documentType,
            isSystem,
            documentstatusid: isPublishedOnly ? 40 : null,
            orderby: "Name:ascending"
        });
    }

    public static async addUpdateDocument(fileName: string, folderPath: string, fileType: string, data: string) {
        let addUpdateDocumentResponse = null;
        let dataPayloadFieldValue = PayloadUtility.createImisPayloadNameValuePair("Data", data, { Data: ImisPayloadFieldType.BINARY }).Value;

        // remove any trailing slashes
        let cleanFolderPath = folderPath.replace(/\/+$/g, "");
        let response: ImisResponseItems<DocumentItem> = await RestUtility.restApiGetData("/api/documentsummary", { path: [cleanFolderPath, fileName].join("/") });
        if (response == null || response.Items.length == 0) {
            let payload = {
                Name: fileName,
                Path: cleanFolderPath,
                Status: "Published",
                DocumentTypeId: fileType,
                Data: null
            };
            if (!Helper.isStringNullOrEmpty(data)) {
                payload.Data = dataPayloadFieldValue;
            }

            addUpdateDocumentResponse = await RestUtility.restApiSendData("/api/document", payload);
        } else {
            // update the existing document
            let documentId = response.Items[0].DocumentId;

            let payload = {
                DocumentId: documentId,
                Name: fileName,
                DocumentTypeId: fileType,
                Data: null
            };
            if (!Helper.isStringNullOrEmpty(data)) {
                payload.Data = dataPayloadFieldValue;
            }

            addUpdateDocumentResponse = await RestUtility.restApiSendData(`/api/document/${documentId}`, payload, "PUT");
        }

        return addUpdateDocumentResponse;
    }

}